import React, { useEffect } from 'react';
import './App.css';
import { Outlet, useNavigate } from 'react-router-dom';
import Nav from './Component/nav/nav.component';
import { Routes, Route } from 'react-router-dom';
import ForgotPassword from './Component/login/ForgotPassword';
import ResetPasswordPage from './Component/login/ResetPasswordPage';

import { useLocation } from 'react-router-dom';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

   useEffect(() => {
    const publicPaths = ['/reset-password', '/Forgot-password', '/Login']; // נתיבים פתוחים
    if (!sessionStorage.getItem("userId") && !publicPaths.includes(location.pathname)) {
      navigate('/Login');
    }
  }, [navigate, location]);

  return (
    <>
      <Nav /> {/* תפריט הניווט */}
      <Routes>
        {/* <Route path="/reset-password" element={<ResetPasswordPage />} /> */}
        <Route path="/Forgot-password" element={<ForgotPassword />} />
      </Routes>
      <Outlet /> {/* מאפשר טעינת תוכן דינמי */}
    </>
  );
};

export default App;
